import React from 'react';
import { cn } from '../../design-system/cn';
import Alert from './Alert';

const TOAST_TONES = {
  success: 'success',
  critical: 'warning',
  error: 'error',
};

/** Fixed-position toast content — used by AppToast. */
export default function Toast({ message, title, variant = 'error', className }) {
  const tone = TOAST_TONES[variant] || TOAST_TONES.error;
  const textTone =
    variant === 'success'
      ? 'text-emerald-100'
      : variant === 'critical'
        ? 'text-amber-100'
        : 'text-red-100';

  return (
    <Alert
      tone={tone}
      role="status"
      className={cn('shadow-xl backdrop-blur-md text-center px-4 py-3 rounded-2xl', textTone, className)}
    >
      {title ? (
        <>
          <p className="text-sm font-black mb-1">{title}</p>
          <p className="text-xs font-bold leading-relaxed">{message}</p>
        </>
      ) : (
        <p className="text-sm font-bold">{message}</p>
      )}
    </Alert>
  );
}
